import { createSlice } from '@reduxjs/toolkit';

const dateSlice = createSlice({
  name: 'dateReducer',
  initialState: {
    date: new Date()
  },
  reducers: {
    saveDate: (state, action) => {
      state["date"] = action.payload.date;
    },
  },
});

export const { saveDate } = dateSlice.actions;

export default dateSlice.reducer;
